module.exports = __webpack_public_path__ + "static/media/list.7e2586c4.svg";